module.exports = __webpack_public_path__ + "img/tuvalu.b60106d5.png";